module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAMCAYAAADGZiUoAAAABGdBTUEAALGPC/xhBQAAALJJREFUSA3dkyESwjAQRd9GYrgCGs8xKnEIPOcBzRRZyTHwaI5QDK5dSJjMNKHBb1Zk5+9E7Jv9Hy7DmXZQWt3jy5oOS88/wlUX9HpDWeFkw5KHKb2T+zwaOBp5IbINH1S70C1pf5xCuTAP9HJAdc1zPGJNF+DSsbW85fumNEiiK8vf15aRsLL8pXAe0lre8n3jof723M/W9AcuzdyUtoL8/doyAlaQvzKch5z6uR9P1vQbeJIJJaKbsJwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/screen/title-right.png
// module id = 9WFq
// module chunks = 1